import type { WasteStreamWithUse } from "../types";

type Props = {
  stream: WasteStreamWithUse;
};

export const StreamEmblem: React.FC<Props> = ({ stream }) => {
  if (stream.status === "active") {
    return (
      <span
        className="flex h-[22px] w-[22px] flex-none items-center justify-center rounded-full"
        style={{ background: "#FBFBE9", color: "#E7EB5D" }}
      >
        <div
          className="h-[14px] w-[14px]"
          style={{
            backgroundImage: `url(${stream.icon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        />
      </span>
    );
  }

  if (stream.status === "recommended") {
    return (
      <span
        className="flex h-[22px] w-[22px] flex-none items-center justify-center rounded-full"
        style={{
          border: "1.125px dashed #C0BE94",
          color: "#87874E",
        }}
      >
        <div
          className="h-[14px] w-[14px]"
          style={{
            backgroundImage: `url(${stream.icon})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        />
      </span>
    );
  }

  return (
    <span
      className="flex h-[30px] w-[30px] flex-none items-center justify-center rounded-full"
      style={{
        background: "#E9E3E3",
        border: "1px solid #D6CECE",
        color: "#9a958f",
      }}
    >
      <div
        className="h-[15.4px] w-[15.4px]"
        style={{
          backgroundImage: `url(${stream.icon})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        }}
      />
    </span>
  );
};
